"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icons = require("../Icons");
var _Input = require("../Input");
var _DropdownMenu = require("../DropdownMenu");
var _SelectInputModule = _interopRequireDefault(require("./SelectInput.module.css"));
var _bind = _interopRequireDefault(require("classnames/bind"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var cx = _bind.default.bind(_SelectInputModule.default);
var SelectInput = _ref => {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    value = _ref.value,
    label = _ref.label,
    helperText = _ref.helperText,
    placeholder = _ref.placeholder,
    alert = _ref.alert,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$itemSize = _ref.itemSize,
    itemSize = _ref$itemSize === void 0 ? 'compact' : _ref$itemSize,
    menuClassName = _ref.menuClassName,
    menuWidth = _ref.menuWidth;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var onOpenChange = open => {
    setIsOpen(open);
  };
  var trigger = /*#__PURE__*/_react.default.createElement(_Input.Input, {
    className: _SelectInputModule.default.InputContainer,
    wrapperClassName: cx(_SelectInputModule.default.Wrapper, {
      WrapperOpen: isOpen
    }),
    inputClassName: _SelectInputModule.default.Input,
    alertClassName: _SelectInputModule.default.Alert,
    helperTextClassName: _SelectInputModule.default.HelperText,
    type: "text",
    label: label,
    placeholder: placeholder,
    value: value,
    helperText: helperText,
    alert: alert,
    error: error,
    endEnhancer: /*#__PURE__*/_react.default.createElement(_Icons.IconChevronDown, {
      size: 16
    })
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ,
    onChange: () => {}
  });
  return /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    menuClassName: menuClassName,
    trigger: trigger,
    items: items,
    open: isOpen,
    onOpenChange: onOpenChange,
    itemSize: itemSize,
    menuWidth: menuWidth
  });
};
exports.SelectInput = SelectInput;
//# sourceMappingURL=SelectInput.js.map